import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/870e9cb5-dbd4-4cce-bdc5-ca6d954495cb";
export const REGISTER_URL = "https://a.ntrk2.com/9ac1a4fc-051a-439c-88dc-7e8a4fc5395f";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://bdpop.loadprkw2a.com/download?openExternalBrowser=1&id=o0ippyjpcv2fd4q";

export * from "./codes";
export * from "./context";
